module.exports = __webpack_public_path__ + "static/img/17.bdabb24.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17.jpeg
// module id = nhAx
// module chunks = 0